import {Injectable} from '@angular/core';
import {ApiService} from '@drl/core/api/api.service';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {BulkDataUpload} from '../commands/bulk-data-upload.command';

@Injectable()
export class BulkEhrDataFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly anyAdapter: AnyAdapter,
  ) {}

  uploadCsv(formData) {
    const command: BulkDataUpload<FormData> = new BulkDataUpload(
      this.apiService,
      this.anyAdapter,
    );
    command.parameters = {
      data: formData,
    };
    return command.execute();
  }
}
